import { AutocompleteWithEndAdornmentChip, LimitedTag, ServerPaginatedTable, useDropdownApis, useFormatAmount } from "../../../shared";
import * as React from "react";
import {
  Button,
  Chip,
  createFilterOptions,
  Checkbox,
  TextField,
  Stack,
  Typography,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import InputControl from "../../../shared/components/InputControl";
import { arraySort } from "../../../utils";
import { DashBoardDateRangePicker } from "../../Dashboard";

export const OrderListComponent = (props) => {
  const formatAmount = useFormatAmount();
  const {
    state,
    globalData,
    filterCollections,
    hasColumnOptions,
    handleApplyFilter,
    HandleFutureOrder, 
    HandleQROrder,
    handleFilter,
    handleDateChangeApply,
    handleIsOpen,
    onChangeDate,
    handleSearch,
    toggleHiddenManualOrder,
    handleSort,
    setPageSize,
    gotoPage,
    handleFilterClear,
    toggleColumns,
    orderColumns,
    discountOrders,
    discountColumns,
    currentTab,
    type,
  } = props;

  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const {
    state: { stores, terminals },
  } = useDropdownApis({
    isStoreList: !isStoreAdmin ? true : false,
    isTerminalsList: true,
  });

  const { filterApplied, pagination, sortBy, disableApplyButton } = state;


  const storeOptions = stores.map((v) => {
    return { value: v.id, label: v.name };
  });

  const terminalOptions = terminals.map((v) => {
    return { value: v.id, label: v.name };
  });

  const ActionButtons = ({ id }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <Link to={`details/${id}`}>
          <img alt="details" src="/icons/arrow_forward.svg" />
        </Link>
      </div>
    );
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Order Number",
        accessor: "order_number",
      },
      {
        Header: "Order Date",
        accessor: "order_date",
        Cell: ({ value }) => {
          return (
            <>
              <div
                style={{
                  width: "100px",
                  wordBreak: "break-word",
                }}
              >
                {value}
              </div>
            </>
          );
        },
      },
      {
        Header: "Provider",
        accessor: "channel_name",
        Cell: ({ value, row }) => {
          let userName =
            row.original.finalised_by_user ?? row.original.user_name;
          return (
            <div>
              {value}
              {userName ? `- ${userName}` : null}
              {row.original.channel_id == "101"
                ? `- ${row.original.platform ?? ""}`
                : ""}
            </div>
          );
        },
      },
      {
        Header: "Order Type",
        accessor: "sales_type",
        Cell: ({ row }) => {
          return (
            <span style={{ textTransform: "capitalize" }}>
              {
                globalData.sale_type.find(
                  (e) => e.value === row.original.sales_type_id
                )?.label
              }
            </span>
          );
        },
      },
      {
        Header: "Store",
        accessor: "store_name",
      },
      {
        Header: "Customer Name",
        id: "customer_first_name",
        accessor: (row) => {
          return (
            <>
              <div>{row.customer_name}</div>
              <Typography variant="caption">{row.email}</Typography>
            </>
          );
        },
      },
      {
        Header: "Order Total",
        accessor: "grand_total",
        Cell: ({ row }) => {
          return (
            <>
              <span>
                {formatAmount(row.original.grand_total || 0)}
              </span>
            </>
          );
        },
      },
      {
        Header: "Discount Amount",
        accessor: "total_discount",
        Cell: ({ row }) => {
          return (
            <span>
              {formatAmount(row.original.total_discount || 0)}
            </span>
          );
        },
      },
      {
        Header: "Order Status",
        accessor: "status",
        Cell: ({ row }) => {
          return (
            <Chip
              label={
                globalData.order_statues.find(
                  (e) => e.value === row.original.status_id
                )?.label
              }
              color={row.original.status_id <= 4 ? "success" : "error"}
              variant="outlined"
              size="small"
              sx={{
                border: "none !important",
              }}
            />
          );
        },
      },
      {
        Header: "Payment Media",
        accessor: "payment_type",
      },
      {
        Header: "Terminal Name",
        accessor: "terminal_name",
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons id={row.id} />;
        },
      },
    ],
    [state.orders]
  );
  const tablecolumns = isStoreAdmin
    ? columns.filter((v) => v.Header !== "Store")
    : columns;

  return (
    <>
      <ServerPaginatedTable
        columns={tablecolumns}
        data={state.orders || []}
        key={sortBy}
        isLoading={state?.isBusy}
        filterApplied={filterCollections}
        drawerOpen={hasColumnOptions}
        columnOptions={discountOrders ? discountColumns : orderColumns}
        defaultSearch={false}
        drawerOnClose={() => toggleColumns()}
        onFilterClear={(e) => handleFilterClear("single", e)}
        onAllFilterClear={(e) => handleFilterClear("all")}
        gotoPage={gotoPage}
        setPageSize={setPageSize}
        pagination={pagination}
        handleSort={handleSort}
        sortByGlobal={sortBy}
        toggleHiddenManual={toggleHiddenManualOrder}
        filterType="new"
        filterContent={
          <>
            <InputControl
              type="table-search"
              value={filterApplied.searchText}
              onChange={(e) => handleSearch(e.target.value)}
              onClear={() => handleSearch("")}
            />
            <Stack direction="row" ml="auto">
              {type === "all-orders" && (
                <Stack direction="row" gap="8px" alignItems="center">
                  <Typography
                    minWidth="110px"
                    fontWeight={400}
                    fontSize="16px"
                  >
                    QR Code Order
                  </Typography>
                  <InputControl
                    type="switch"
                    checked={
                      state?.filterApplied?.qr_orders === 1 ? true : false
                    }
                    onChange={() => {
                      HandleQROrder(
                        state?.filterApplied?.qr_orders === 1 ? 0 : 1
                      );
                    }}
                  />
                </Stack>
              )}
              <Stack direction="row" gap="8px" alignItems="center">
                <Typography
                  minWidth="110px"
                  fontWeight={400}
                  fontSize="16px"
                >
                  Future Orders
                </Typography>
                <InputControl
                  type="switch"
                  checked={
                    state?.filterApplied?.feature_order === 1 ? true : false
                  }
                  onChange={() => {
                    HandleFutureOrder(
                      state?.filterApplied?.feature_order === 1 ? 0 : 1
                    );
                  }}
                />
              </Stack>
            </Stack>
          </>
        }
        filterSection={
          <>
            <Stack
              direction="row"
              gap="16px"
              alignItems="center"
              flexWrap="wrap"
            >
              <DashBoardDateRangePicker
                onChangeDate={onChangeDate}
                isList={true}
                range={state.date}
                showRange={state.showDate}
                isOpen={state.isCalenderOpen}
                handleIsOpen={handleIsOpen}
                handleDateChangeApply={handleDateChangeApply}
                position="left"
                hasFutureDate={true}
              />
              {currentTab === "1" ? (
                <>
                  <AutocompleteWithEndAdornmentChip
                    name="status"
                    label="Status"
                    options={globalData.order_statues ?? []}
                    value={filterApplied.status}
                    handleChangeFilter={handleFilter}
                    groupBy={() => "All"}
                    limitedTag={(value) => (
                      <LimitedTag
                        labelKey="label"
                        value={value}
                        autocompleteWidth="230px"
                        labelWidth="110px"
                      />
                    )}
                    renderGroup={(params) => {
                      const isAllChecked = filterApplied.status.length === globalData.order_statues.length;
                      return (
                        <React.Fragment key={params.group}>
                          {params.key === 0 && (
                            <ListItemButton
                              disableGutters
                              onClick={() =>
                                handleFilter({
                                  event: null,
                                  name: "status",
                                  value: isAllChecked ? [] : globalData.order_statues,
                                })
                              }
                              selected={isAllChecked}
                            >
                              <Checkbox size="small" checked={isAllChecked} />
                              <Typography>All</Typography>
                            </ListItemButton>
                          )}

                          <ListItemText>{params.children}</ListItemText>
                        </React.Fragment>
                      );
                    }}
                    sx={{ minWidth: 230, maxWidth: "fit-content", }}
                  />
                </>
              ) : (
                ""
              )}
              {!isStoreAdmin && (
                <AutocompleteWithEndAdornmentChip
                  name="stores"
                  label="Store"
                  options={arraySort(storeOptions || [], "label")}
                  value={filterApplied.stores}
                  handleChangeFilter={handleFilter}
                  limitedTag={(value) => (
                    <LimitedTag
                      labelKey="label"
                      value={value}
                      autocompleteWidth="230px"
                      labelWidth="110px"
                    />
                  )}
                  groupBy={() => "All"}
                  renderGroup={(params) => {
                    const isAllChecked = filterApplied.stores.length === storeOptions.length;
                    return (
                      <React.Fragment key={params.group}>
                        {params.key === 0 && (
                          <ListItemButton
                            disableGutters
                            onClick={() =>
                              handleFilter({
                                event: null,
                                name: "stores",
                                value: isAllChecked ? [] : storeOptions,
                              })
                            }
                            selected={isAllChecked}
                          >
                            <Checkbox size="small" checked={isAllChecked} />
                            <Typography>All</Typography>
                          </ListItemButton>
                        )}

                        <ListItemText>{params.children}</ListItemText>
                      </React.Fragment>
                    );
                  }}
                  sx={{ minWidth: 230, maxWidth: "fit-content" }}
                />

              )}
              <AutocompleteWithEndAdornmentChip
                name="type"
                label="Type"
                options={globalData.sale_type ?? []}
                value={filterApplied.type}
                handleChangeFilter={handleFilter}
                limitedTag={(value) => (
                  <LimitedTag
                    labelKey="label"
                    value={value}
                    autocompleteWidth="190px"
                    labelWidth="80px"
                  />
                )}
                groupBy={() => "All"}
                renderGroup={(params) => {
                  const isAllChecked = filterApplied.type.length === (globalData.sale_type?.length ?? 0);
                  return (
                    <React.Fragment key={params.group}>
                      {params.key === 0 && (
                        <ListItemButton
                          disableGutters
                          onClick={() =>
                            handleFilter({
                              event: null,
                              name: "type",
                              value: isAllChecked ? [] : globalData.sale_type,
                            })
                          }
                          selected={isAllChecked}
                        >
                          <Checkbox size="small" checked={isAllChecked} />
                          <Typography>All</Typography>
                        </ListItemButton>
                      )}
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }}
                sx={{ minWidth: 190, maxWidth: "fit-content" }}

              />
              <AutocompleteWithEndAdornmentChip
                name="channel"
                label="Sales Channel"
                options={globalData?.sale_channels ?? []}
                value={filterApplied.channel}
                handleChangeFilter={handleFilter}
                limitedTag={(value) => (
                  <LimitedTag
                    labelKey="label"
                    value={value}
                    autocompleteWidth="220px"
                    labelWidth="110px"
                  />
                )}
                groupBy={() => "All"}
                renderGroup={(params) => {
                  const isAllChecked = filterApplied.channel.length === (globalData.sale_channels?.length ?? 0);
                  return (
                    <React.Fragment key={params.group}>
                      {params.key === 0 && (
                        <ListItemButton
                          disableGutters
                          onClick={() =>
                            handleFilter({
                              event: null,
                              name: "channel",
                              value: isAllChecked ? [] : globalData.sale_channels,
                            })
                          }
                          selected={isAllChecked}
                        >
                          <Checkbox size="small" checked={isAllChecked} />
                          <Typography>All</Typography>
                        </ListItemButton>
                      )}
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }}
                sx={{ minWidth: 220, maxWidth: "fit-content" }}
              />
              {type === "all-orders" && (
                <AutocompleteWithEndAdornmentChip
                  name="terminal"
                  label="Terminal"
                  options={arraySort(terminalOptions || [], "label")}
                  value={filterApplied.terminal}
                  handleChangeFilter={handleFilter}
                  limitedTag={(value) => (
                    <LimitedTag
                      labelKey="label"
                      value={value}
                      autocompleteWidth="220px"
                      labelWidth="110px"
                    />
                  )}
                  groupBy={() => "All"}
                  renderGroup={(params) => {
                    console.log(filterApplied, terminalOptions);

                    const isAllChecked = filterApplied.terminal.length === terminalOptions.length;
                    return (
                      <React.Fragment key={params.group}>
                        {params.key === 0 && (
                          <ListItemButton
                            disableGutters
                            onClick={() =>
                              handleFilter({
                                event: null,
                                name: "terminal",
                                value: isAllChecked ? [] : terminalOptions,
                              })
                            }
                            selected={isAllChecked}
                          >
                            <Checkbox size="small" checked={isAllChecked} />
                            <Typography>All</Typography>
                          </ListItemButton>
                        )}
                        <ListItemText>{params.children}</ListItemText>
                      </React.Fragment>
                    );
                  }}
                  sx={{ minWidth: 220, maxWidth: "fit-content" }}
                />
              )}
              <AutocompleteWithEndAdornmentChip
                name="customer_type"
                label="Customer Type"
                options={globalData?.customer_type ?? []}
                value={filterApplied.customer_type}
                handleChangeFilter={handleFilter}
                limitedTag={(value) => (
                  <LimitedTag
                    labelKey="label"
                    value={value}
                    autocompleteWidth="200px"
                    labelWidth="110px"
                  />
                )}
                groupBy={() => "All"}
                renderGroup={(params) => {
                  const isAllChecked = filterApplied.customer_type.length === (globalData.customer_type?.length ?? 0);
                  return (
                    <React.Fragment key={params.group}>
                      {params.key === 0 && (
                        <ListItemButton
                          disableGutters
                          onClick={() =>
                            handleFilter({
                              event: null,
                              name: "customer_type",
                              value: isAllChecked ? [] : globalData.customer_type,
                            })
                          }
                          selected={isAllChecked}
                        >
                          <Checkbox size="small" checked={isAllChecked} />
                          <Typography>All</Typography>
                        </ListItemButton>
                      )}
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }}
                sx={{ minWidth: 200, maxWidth: "fit-content" }}
              />
              <AutocompleteWithEndAdornmentChip
                name="payment"
                label="Payment Media"
                options={globalData?.payment_types ?? []}
                value={filterApplied.payment}
                handleChangeFilter={handleFilter}
                limitedTag={(value) => (
                  <LimitedTag
                    labelKey="label"
                    value={value}
                    autocompleteWidth="210px"
                    labelWidth="110px"
                  />
                )}
                groupBy={() => "All"}
                renderGroup={(params) => {
                  const isAllChecked = filterApplied.payment.length === (globalData.payment_types?.length ?? 0);
                  return (
                    <React.Fragment key={params.group}>
                      {params.key === 0 && (
                        <ListItemButton
                          disableGutters
                          onClick={() =>
                            handleFilter({
                              event: null,
                              name: "payment",
                              value: isAllChecked ? [] : globalData.payment_types,
                            })
                          }
                          selected={isAllChecked}
                        >
                          <Checkbox size="small" checked={isAllChecked} />
                          <Typography>All</Typography>
                        </ListItemButton>
                      )}
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }}
                sx={{ minWidth: 210, maxWidth: "fit-content" }}
              />
              <AutocompleteWithEndAdornmentChip
                name="platform"
                label="Ordering Platform"
                options={globalData?.order_platform ?? []}
                value={filterApplied.platform}
                handleChangeFilter={handleFilter}
                limitedTag={(value) => (
                  <LimitedTag
                    labelKey="label"
                    value={value}
                    autocompleteWidth="220px"
                    labelWidth="110px"
                  />
                )}
                groupBy={() => "All"}
                renderGroup={(params) => {
                  const isAllChecked = filterApplied.platform.length === (globalData.order_platform?.length ?? 0);
                  return (
                    <React.Fragment key={params.group}>
                      {params.key === 0 && (
                        <ListItemButton
                          disableGutters
                          onClick={() =>
                            handleFilter({
                              event: null,
                              name: "platform",
                              value: isAllChecked ? [] : globalData.order_platform,
                            })
                          }
                          selected={isAllChecked}
                        >
                          <Checkbox size="small" checked={isAllChecked} />
                          <Typography>All</Typography>
                        </ListItemButton>
                      )}
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }}
                sx={{ minWidth: "220px", maxWidth: "fit-content" }}
              />
              <Button
                color="info"
                sx={{ width: "81px", minWidth: "81px", height: "30px" }}
                onClick={() => handleFilterClear("all")}
                disabled={filterCollections.length == 0}
              >
                Clear All
              </Button>
              <Stack direction="row" ml="auto">

                <Button
                  type="button"
                  size="medium"
                  variant="text"
                  color="info"
                  sx={{
                    minWidth: "40px",
                    p: "8px",
                  }}
                  disabled={disableApplyButton}
                  onClick={() => handleApplyFilter()}
                >
                  Apply
                </Button>
              </Stack>
            </Stack>
          </>
        }
        onRowLink={(e) => {
          return `details/${e.id}`;
        }}
      />
    </>
  );
};
